import React from 'react';
import { Button } from '@mui/material';
import { Translate } from 'react-localize-redux';

interface ViewPatientOnListButtonProps {
  onClick: () => void;
}

export function ViewPatientOnListButton({ onClick }: ViewPatientOnListButtonProps) {
  return (
    <Button
      type="button"
      variant="text"
      color="primary"
      data-testid="view-patient-on-list-button"
      onClick={onClick}
    >
      <Translate id="hospital.patient.toolbar.view_patient_on_list" />
    </Button>
  );
}
